import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cn } from '../../lib/utils';
import { Icon } from './icon';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded border-2 border-[var(--input-border-default)] bg-surface ring-offset-surface transition-all duration-150 hover:border-[var(--input-border-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue-500/30 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-brand-blue-600 data-[state=checked]:bg-brand-blue-600 data-[state=checked]:text-white data-[state=checked]:shadow-sm data-[state=indeterminate]:border-brand-blue-600 data-[state=indeterminate]:bg-brand-blue-100 data-[state=indeterminate]:text-brand-blue-700',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn(
        'group flex items-center justify-center text-current transition-transform duration-150 data-[state=checked]:scale-100 data-[state=indeterminate]:scale-100 data-[state=unchecked]:scale-0'
      )}
    >
      <Icon name="check" className="text-xs group-data-[state=indeterminate]:hidden" />
      <Icon name="remove" className="text-xs group-data-[state=checked]:hidden" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
